export enum OrderAttachmentType {
    NAROCILNICA = 'narocilnica',
    NAROCNISKI_LIST = 'narocniski_list',
    DWG = 'dwg',
    DRUGO = 'drugo',
}

export const orderAttachmentTypeOptions = [
    { value: OrderAttachmentType.NAROCILNICA, label: 'Naročilnica' },
    { value: OrderAttachmentType.NAROCNISKI_LIST, label: 'Naročniški list' },
    { value: OrderAttachmentType.DWG, label: 'DWG datoteka' },
    { value: OrderAttachmentType.DRUGO, label: 'Drugo' },
];